import { render, staticRenderFns } from "./WsTechnicalExpertCard.vue?vue&type=template&id=bb9b4336&scoped=true"
import script from "./WsTechnicalExpertCard.vue?vue&type=script&lang=js"
export * from "./WsTechnicalExpertCard.vue?vue&type=script&lang=js"
import style0 from "./WsTechnicalExpertCard.vue?vue&type=style&index=0&id=bb9b4336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9b4336",
  null
  
)

export default component.exports